import {makeStyles} from '@material-ui/core/styles';


export const useStyles = makeStyles(() => ({
  bgBlue: {
    backgroundColor: '#E7F0FF',
  },
  card: {
    background: '#FFFFFF',
    boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.2)',
    borderRadius: '8px',
    margin: '0 40px'
  },
  actionButton: {
    color: '#32324D',
    border: '1px solid #DCDCE4',
    background: '#F6F6F9',
    marginLeft: '15px'
  },
  customSearch: {
    borderTopLeftRadius: '6px',
    borderBottomLeftRadius: '6px',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7F0FF'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#4B6FC2',
      opacity: '1'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4B6FC2'
    }
  },
  customSearchField: {
    borderTopRightRadius: '6px',
    borderBottomRightRadius: '6px',

    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#E7F0FF'
    },
    '& .MuiInputBase-input::-webkit-input-placeholder': {
      color: '#4B6FC2',
      opacity: '1'
    },
    '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: '#4B6FC2'
    },
    '& .MuiInputAdornment-root .MuiTypography-colorTextSecondary': {
      color: '#4B6FC2'
    }
  },
  helperText: {
    position: 'absolute',
    bottom: '-15px',
    left: '25px'
  },
  filterBtn: {
    padding: '7px 15px',
    marginLeft: '10px'
  },
  toolbarContainer: {
    borderBottom: '1px solid #D0E9FF'
  },
  paginationContainer: {
    background: '#E7F0FF',
    color: '#4B6FC2',

    '& .MuiSelect-icon': {
      color: '#4B6FC2'
    },

    '& .MuiIconButton-root.Mui-disabled': {
      color: '#4B6FC2',
      opacity: '0.44'
    }
  },
  table: {
    '&.MuiTable-root': {
      tableLayout: 'auto',
      minWidth: '1000px',
      overflowX: 'auto',
    },
    '& .MuiTableCell-root': {
      borderBottomColor: '#D0E9FF'
    },
    '& .MuiTableCell-head': {
      textTransform: 'uppercase',
      color: '#4277C6',
      fontWeight: '600',
      letterSpacing: '0.05em',
      fontSize: '12px',
      '&:first-child': {
        paddingLeft: '15px',
      }
    },
    '& .MuiTableBody-root': {
      paddingLeft: '5px'
    },
    '& .MuiTableSortLabel-root.MuiTableSortLabel-active': {
      color: '#4277C6'
    },
    '& .MuiTableCell-body': {
      paddingLeft: '5px',
      color: '#777',
      '&:first-child': {
        paddingLeft: '15px',
      }
    },
    '& .MuiSvgIcon-root': {
      fill: '#4B6FC2',
      fontSize: '24px'
    },
    '& .MuiSvgIcon-root.MuiTableSortLabel-icon': {
      fontSize: '14px'
    },
    '& .MuiTableCell-paddingCheckbox': {
      width: '60px',
      padding: '0 10px'
    },
    '& .MuiTableRow-root.Mui-selected, .MuiTableRow-root.Mui-selected:hover': {
      backgroundColor: 'rgba(231, 240, 255, 0.8)'
    },
    '& .indicator': {
      borderRadius: '10px',
      fontWeight: '500',
      fontSize: '12px',
      lineHeight: '15px',
      padding: '5px 10px',
      textTransform: 'capitalize',
      background: '#E1E1E1'
    },
    '& .indicator::before': {
      content: '\'\'',
      display: 'inline-block',
      width: '4px',
      height: '4px',
      borderRadius: '4px',
      margin: '0 4px 2px 0',
      background: '#848484',
      color: '#848484'
    },
    '& .processing.indicator::before': {
      background: '#CE8500'
    },
    '& .complete.indicator::before': {
      background: '#007F00'
    },
    '& .canceled.indicator::before': {
      background: '#848484'
    },
    '& .holded.indicator::before': {
      background: '#D30000'
    },
    '& .processing': {
      background: '#FFECCC',
      color: '#965E00'
    },
    '& .complete': {
      background: '#CDFFCD',
      color: '#007F00'
    },
    '& .canceled': {
      background: '#E1E1E1',
      color: '#848484'
    },
    '& .holded': {
      background: '#FFE0E0',
      color: '#D30000'
    }
  },
  tabIndicator: {
    borderBottom: '2px solid #DCDCE4',
  },
  activeTab: {
    fontWeight: 'bold',
    background: '#103A99FC',
    color: '#fff',
  },
  inactiveTab: {
    fontWeight: 'bold',
    background: '#f0f8ff',
    color: '#434343',
  },
  tabsContainer: {
    '& .MuiTab-root': {
      fontSize: '11px',
      fontWeight: 'bold',
      borderRadius: '8px 8px 0px 0px'
    },
    '& .MuiTabs-root': {
      padding: '0 1%',
      '& .MuiTab-root': {
        width: 'calc(100%/4 - 2px)',
      }
    },
    '& .MuiTabs-indicator': {
      display: 'none'
    },
    '& .tab': {
      padding: '20px 9%'
    },
    '& .MuiTab-textColorPrimary': {
      color: '#434343',
      backgroundColor: '#f0f8ff',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      margin: '5px 1px -1px',
      border: '1px solid #D0E9FF'
    },
    '& .MuiTab-textColorPrimary.Mui-selected': {
      background: '#103A99',
      color: '#fff'
    },
    '& .MuiTableCell-body.MuiTableCell-root': {
      color: '#434343'
    },
  }
}));
